import React, { useCallback } from 'react';
import { _ } from '@hugendubel/utils';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { Button, A } from '@hugendubel/react-basic';
import { OnlineAvailability } from './OnlineAvailability';
import { __ } from 'first-intl';
import { Config } from '../../../config';
import { ArticleStockCount } from './ArticleStockCount';
import { ModalController } from '../modal/ModalController';
import { CoverImg } from '@hugendubel/article';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

export type ArticleBoxProps = {
    article: ReducedProduct;
    isPurchasable?: boolean;
    isBranchOnlyArticle?: boolean;
    buyButtonUrl?: string;
    pickupButtonHandler?: () => void;
    showPrice: boolean;
};

export const ArticleBox: React.FC<ArticleBoxProps> = ({
    article,
    buyButtonUrl,
    pickupButtonHandler,
    showPrice,
    isPurchasable,
    isBranchOnlyArticle,
}) => {
    const {
        attributes: { title, authors, ean, coverImage },
        price,
        productType: { name },
        deliveryInformation,
        availability,
    } = article;

    const openDetails = useCallback(() => ModalController.openArticleDetails(article), [article]);

    // productType.name
    // coverLargeImagePath - die cover url die wir schon haben

    return (
        <div className="row">
            <div className="cover-col col col-xs-4 col-sm-3 clickable" onClick={openDetails}>
                <CoverImg coverPath={coverImage} />
            </div>
            <div className="details-col col col-xs-8 col-sm-9">
                <div className="primary-item-info">
                    <div className="title clickable" onClick={openDetails}>
                        {title}
                    </div>
                    <div className="authors">{authors}</div>
                </div>
                <div className="secondary-item-info">
                    <div className="item-type">{name}</div>
                    {showPrice && (
                        <div className="price price-secondary">
                            <span className="priceOnly">{price.bonusCost}</span>{' '}
                            <span className="priceCurrency">{__('points')}</span>
                        </div>
                    )}
                    <OnlineAvailability availabilityData={availability} />
                    {Config.get().isPhysicalBookstore && !deliveryInformation?.download && (
                        <ArticleStockCount ean={ean} />
                    )}
                </div>
            </div>
            {buyButtonUrl && (
                <div className="action-col col col-sm-9">
                    {pickupButtonHandler && (
                        <Button
                            type="button"
                            onClick={pickupButtonHandler}
                            disabled={!isPurchasable}
                            label="article.box.button.pickup"
                            className={_.classNames('btn btn-default', !isPurchasable && 'btn-disabled')}
                        />
                    )}
                    {!isBranchOnlyArticle && (
                        <A
                            trackId={TRACK_ID('2019-07-30 08:09:43')}
                            href={buyButtonUrl}
                            disabled={!isPurchasable}
                            className={_.classNames('btn btn-primary', !isPurchasable && 'btn-disabled')}
                        >
                            {__('article.box.button.buy')}
                        </A>
                    )}
                </div>
            )}
        </div>
    );
};
